import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = logged out, object = logged in
  const [user, setUser] = useState(() => (localStorage.getItem("fiorucci_token") ? null : false));

  const handleAuthFail = () => {
    localStorage.removeItem("fiorucci_token");
    setUser(false);
  };

  useEffect(() => {
    if (!localStorage.getItem("fiorucci_token")) return;
    api.get("/auth/me").then((res) => setUser(res.data)).catch(handleAuthFail);
  }, []);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("fiorucci_token", res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("fiorucci_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
